const CollegeActionTypes = {
  UPDATE_TO_ROOT: "UPDATE_TO_ROOT_COLLEGE",
  UPDATE_USER_DETAILS: "UPDATE_USER_DETAILS",
  UPDATE_COLLEGE_DETAILS: "UPDATE_COLLEGE_DETAILS",
  UPDATE_INST_LOGO: "UPDATE_INST_LOGO",
  UPDATE_INST_TAGLINE: "UPDATE_INST_TAGLINE",
  UPDATE_INST_CAN_DELIVER: "UPDATE_INST_CAN_DELIVER",
  UPDATE_INST_WEBSITE: "UPDATE_INST_WEBSITE",
  ADD_CAMPUS: "ADD_CAMPUS",
  ADD_CAMPUS_TO_PERSONNEL: "ADD_CAMPUS_TO_PERSONNEL",
  EDIT_CAMPUS: "EDIT_CAMPUS",
  DELETE_CAMPUS: "DELETE_CAMPUS",
  CREATE_PERSONNEL: "CREATE_PERSONNEL",
  UPDATE_PERSONNEL: "UPDATE_PERSONNEL",
  DELETE_PERSONNEL: "DELETE_PERSONNEL",
  ADD_CLASS: "ADD_CLASS",
  EDIT_CLASS: "EDIT_CLASS",
  EDIT_CLASS_REFERENCENAME: "EDIT_CLASS_REFERENCENAME",
  DELETE_CLASS: "DELETE_CLASS",
  ADD_REMOVE_FAVOURITE_TEACHER: "ADD_REMOVE_FAVOURITE_TEACHER",
  UPDATE_PERSONNEL_DETAILS: "UPDATE_PERSONNEL_DETAILS",
  BLOCK_UNBLOCK_TEACHER: "BLOCK_UNBLOCK_TEACHER",
  UPDATE_CUSTOMER_INFO: "UPDATE_CUSTOMER_INFO",
  UPDATE_INSTITUTION_INFO: "UPDATE_INSTITUTION_INFO",
  UPDATE_INST_ROOMS_PROGRAMS: "UPDATE_INST_ROOMS_PROGRAMS",
}

export default CollegeActionTypes;
